<template>
	<div style="margin-top: -16px;background: #F4F4F4;">
		<div class="banner" style="min-width: 1344px;">
			<el-carousel trigger="click" height="424px" :interval="5000" arrow="never">
				<el-carousel-item v-for="(item,i) in rotationChart" :key="i">
					<img :src="getUrl(item.imageUrl)" style="width: 100%;height: 100%;" @click="goUrl(item)"/>
				</el-carousel-item>
			</el-carousel>
			<div class="addr" v-if="$store.state.pageInfo && $store.state.pageInfo.addr">
				<p :title="$store.state.pageInfo.addr" class="ellipsis"><img src="@/assets/img/addr.png"/>&nbsp;样品邮寄地址：{{ $store.state.pageInfo.addr }}</p>
			</div>
		</div>
		<div class="mod-home site-wrapper" style="border-radius: 16px 16px 16px 16px;padding-top: 8px;">
			<el-tabs v-loading="bannerTabLoading" class="topTab" @tab-click="getBannerTab" v-model="activeName" style="z-index: 2;">
				<el-tab-pane label="常规检项" name="ZYGL_CGJX"></el-tab-pane>
				<el-tab-pane label="操作指南" name="ZYGL_CZZN"></el-tab-pane>
				<el-tab-pane label="资源共享" name="ZYGL_ZYGX"></el-tab-pane>
				<a :class="getClass(item.fileName.slice(item.fileName.lastIndexOf('.')+1))" :key="i" v-for="(item,i) in resourceList" @click.prevent="downloadFile(item.fileUrl,item.fileName)">{{ item.fileName }}</a>
				<p style="text-align: center;">
					<el-button type="text" style="font-size: 12px;" @click="$router.push({ name: 'resourceManage' })">
						查看更多
						<i class="el-icon-arrow-right el-icon--right"></i>
					</el-button>
				</p>
			</el-tabs>
			<div class="screen" style="padding-left: 16px;padding-right:6px;">
				<el-form :inline="true" size="small" class="fillet_form clearFloat">
					<!-- <el-form-item>
						<div class="catSelectBox">
							<span :class="'ellipsis'+(v.active?' active':'')" @click="setCurrent(v)"
								v-for="(v,i) in (catType.length && catType.slice(0,8)) || []"
								:key="i">{{v.goodsName || '/'}}</span>
							<el-popover placement="bottom" width="400" trigger="click">
								<span :class="['ellipsis','catOtherItems',{active:v.active}]" @click="setCurrent(v)"
									v-for="(v,i) in catType.slice(8,catType.length)" :key="i">{{v.goodsName || '/'}}</span>
								<span v-show="catType.length>8" slot="reference">更多>></span>
							</el-popover>
						</div>
					</el-form-item> -->
					<el-form-item>
						<el-cascader
							clearable
							filterable
							:props="defaultProps"
							v-model="goodsPrn"
							:options="catType"
							@change="treeChange">
						</el-cascader>
					</el-form-item>
					
					<el-form-item class="fr">
						<el-input placeholder="请输入内容" v-model="keyword" @keyup.enter.native="getDataList" @blur="getDataList" @clear="getDataList"
							clearable suffix-icon="el-icon-search"> </el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="mod-service" v-loading="goodsLoading">
				<div v-if="noGoodsData" style="width: 300px;margin: 0 auto;text-align: center;margin-top: 82px;">
					<img src="@/assets/img/noData.png" height="128" width="141" />
					<p style="font-size: 24px;font-weight: bold;margin-bottom:38px;margin-top:16px;">哦豁！当前分类暂无数据。</p>
				</div>
				<ul v-else class="service-list">
					<li v-for="(item, index) of goods" :key="index">
						<dl v-if="item.goodsName=='自由送检'">
							<dt style="cursor: pointer;">
								<img :src="img" @click="quickOrderClick('')"/>
							</dt>
							<dd>
								<h3 class="ser_name ellipsis" :title="item.goodsName">{{ item.goodsName }}</h3>
								<p class="desc" :title="item.goodsDesc">自定义报检可手动添加样品和检项下单</p>
								<div style="position: absolute;top: 105px;width: 197px;" v-if="$cookie.get('X-Admin-Token')">
									<p class="price"></p>
									<div class="btn_group">
										<button style="width: 100%;" class="diy_button primary_button" @click="quickOrderClick('')">快速下单</button>
									</div>
								</div>
								
							</dd>
						</dl>
						<dl v-else>
							<dt title="查看详情" style="cursor: pointer;" @click="goDetails(item.prn)">
								<!-- <el-image :fit="cover" :src="item.goodsImage.length>0 ? item.goodsImage[0] : imgDefult">
									<div slot="error" class="image-slot">
										<img :src="imgDefult" />
									</div>
								</el-image> -->
								<img
									:src="item.goodsImage.length>0 ? getUrl(item.goodsImage[0]) : imgDefult" />
							</dt>
							<dd>
								<h3 class="ser_name ellipsisY" :title="item.goodsName">{{ item.goodsName }}</h3>
								<p class="desc" :title="item.goodsDesc">{{ item.goodsDesc }}</p>
								<div style="position: absolute;top: 103px;">
									<p class="price">
										{{item.valuation && '¥'+item.valuation || '--'}}
										<!-- <span>{{item.totalPrice && '¥'+item.totalPrice || ''}}</span> -->
									</p>
									<div class="btn_group">
										<button class="diy_button normal_button" @click="joinCartHandle(item.prn)"><img src="@/assets/img/cart_1.png" width="20px" height="20px"/>加入购物车</button>
										<!-- <button class="diy_button normal_button" @click="removeCartHandle(item.prn)"
											v-if="item.inCart"><i class="el-icon-shopping-cart-2"></i>取消购物车</button> -->
										<button style="padding: 7px 9px;" class="diy_button primary_button" @click="quickOrderClick(item.prn)">快速下单</button>
									</div>
								</div>
								
							</dd>
						</dl>
					</li>
				</ul>
			</div>
			<div class="mod-page" v-if="goods.length>0">
				<pagination v-show="totalPage > 0" :total="totalPage" :page.sync="pageIndex" :limit.sync="pageLimt"
					@pagination="getDataList" />
			</div>
		</div>
	</div>
</template>

<script>
    import { Loading } from 'element-ui';
	import Pagination from "@/components/Pagination";
	import { downloadFile,previewUrl } from "@/utils";
	export default {
		components: {
			Pagination
		},
		data() {
			return {
				img: require("@/assets/img/zysj.png"),
				imgDefult: require("@/assets/img/noImg.png"),
				goods: [],
				catType: [{
					goodsName: '全部',
					prn: '',
					active: true
				}],
				keyword: "",
				goodsPrn: [],
				pageIndex: 1,
				pageLimt: 10,
				totalPage: 0,
				activeName: "ZYGL_CGJX",
				rotationChart: [],
				timeout:null,
				goodsLoading:false,
				noGoodsData:false,
				resourceList:[],
				bannerTabLoading:false,
				defaultProps:{
					value:'prn',
          children: 'childrenList',
          label: 'goodsName'
        }
			};
		},
		created() {
			this.getCatType();
			this.getBannerTab();
			this.getBanner();
			const serach = location.href.split('code=');
			if(serach.length>1){
				let loadingInstance = Loading.service({ fullscreen: true,text: '登录中...' });
				let code = serach[1].split('&')[0];
				if(code.indexOf("#/")>-1){
					code = code.split('#/')[0];
				}
				this.$http.post(this.$api.shiroApi.fbcLogin,{code:code}).then(({
					data
				}) => {
					loadingInstance.close();
					this.$cookie.set("X-Admin-Token", data.data.token);
					this.$cookie.set("name", data.data.userInfo.name);
					this.$cookie.set("userid", data.data.userInfo.id);
					this.$cookie.set("isAdmin", data.data.userInfo.isAdmin);
					this.$cookie.set("avatar", data.data.userInfo.avatar || '');
					this.$cookie.set("isOtherUser", data.data.userInfo.isOtherUser);
					this.$cookie.set("userType", data.data.userInfo.userType);
					location.href = window.SITE_CONFIG["baseUrl"]+"/#/home";
				}).catch(()=>{});
			}
		},
		beforeDestroy() {
			clearTimeout(this.timeout);
		},
		methods: {
			treeChange(){
				this.pageIndex = 1;
				this.getDataList();
			},
			getUrl(url){
				return previewUrl(url);
			},
			downloadFile(url, fileName) {
				downloadFile(url, fileName);
			},
			// setCurrent(item) {
			// 	this.catType.forEach(element => {
			// 		element.active = false;
			// 	});
			// 	this.goodsPrn = item.prn;
			// 	item.active = true;
			// 	this.pageIndex = 1;
			// 	this.getDataList();
			// },
			getClass(type) {
				if ('pdf'.indexOf(type) != -1) {
					return 'pdf'
				}
				if ('docx'.indexOf(type) != -1) {
					return 'word'
				}
				if ('xlsx'.indexOf(type) != -1) {
					return 'excel'
				}
			},
			getBanner() {
				this.$http.get(this.$api.bannerApi.getBanner,{params:{type:'BANNER_SY'}}).then(({
					data
				}) => {
					this.rotationChart = data.data || [];
				});
			},
			getBannerTab() {
				this.bannerTabLoading = true;
				let param = {
					current: 1,
					size: 5,
					data: {
						type: this.activeName
					}
				}
				this.$http.post(this.$api.bannerApi.getResource,param).then(({
					data
				}) => {
					this.bannerTabLoading = false;
					this.resourceList = data.data.list;
				}).catch(()=>{
					this.bannerTabLoading = false;
				});
			},
			// 获取服务列表
			getDataList() {
				this.goodsLoading = true;
				let params = {
					current: this.pageIndex,
					size: this.pageLimt,
					data: {
						prn: this.goodsPrn.length>0?this.goodsPrn[this.goodsPrn.length-1]:'',
						goodsName: this.keyword,
    					st: 1
					}
				};
				this.$http.post(this.$api.goodsApi.list, params).then(({
					data
				}) => {
					this.goodsLoading = false;
					this.goods = data.data.list || [];
					this.totalPage = data.data.total;
					this.noGoodsData = !this.goods.length;
				}).catch(()=>{
					this.goodsLoading = false;
				});
			},
			//获取树
			getCatType() {
				this.$http.get(this.$api.goodsApi.catType, {
					params: {
						isGoods: false
					}
				}).then(({
					data
				}) => {
					// this.catType = [{
					// 	goodsName: '全部',
					// 	prn: '',
					// 	active: true
					// }].concat(data.data);
					this.catType = data.data;
					if (this.catType.length > 0) {
						this.getDataList();
					}
				});
			},
			// 加入购物车
			joinCartHandle(prn) {
				this.$http.get(this.$api.orderApi.addCart, {
					params: {
						goodsPrn: prn
					}
				}).then(({
					data
				}) => {
					this.$message({
						message: data.msg,
						type: "success"
					});
					this.$store.commit("updateCartTotal", parseInt(this.$store.state.cartTotal) + 1);
				});
			},
			// 取消加入购物车
			removeCartHandle(prn) {
				let prns = prn ? [prn] : [];
				this.$http.post(this.$api.cartApi.delete, {
					goodsPrns: prns
				}).then(({
					data
				}) => {
					if (data.code === 200) {
						this.$message({
							message: "取消成功",
							type: "success",
							duration: 1500,
							onClose: () => {
								this.$store.commit("updateCartTotal", parseInt(this.$store.state
									.cartTotal) - prns.length);
								this.getDataList();
							},
						});
					}
				});
			},
			// 快速下单
			quickOrderClick(prn){
				if (this.timeout) {
					clearTimeout(this.timeout);
				}
				this.timeout = setTimeout(() => {
					this.quickOrderHandle(prn || '');
				}, 500);
			},
			quickOrderHandle(prn) {
				let params = {
					goodsPrn: prn,
					projectIds: []
				}
				this.$http.post(this.$api.orderApi.orderAdd, params).then(({
					data
				}) => {
					this.$message({
						message: "下单成功",
						type: "success"
					});
          			this.visible = false;
					this.$router.push({
						name: "inspection",
						query: {
							orderId: data.data
						}
					});
				});
			},
			goDetails(prn) {
				this.$router.push({
					path: "/goods-details",
					query: {
						prn: prn,
					},
				});
			},
			// 轮播图跳转
			goUrl(item) {
				if(!item.url)return
				location.href = item.url;
			}
		}
	};
</script>

<style lang="scss" scoped>
	.catSelectBox span,
	.catOtherItems {
		width: 96px;
		height: 32px;
		text-align: center;
		line-height: 32px;
		border-radius: 16px;
		display: inline-block;
		margin-right: 7px;
		cursor: pointer;
		vertical-align: middle;
		padding: 0 8px;

		&.active {
			background: #e7eff7;
			color: #1460AE;
			font-weight: bold;
			font-size: 16px;
		}
	}

	.mod-home {
		padding: 51px 0 41px 0;
		background: #f4f4f4;

		.mod-banner {
			margin-top: 27px;

			img {
				width: 100%;
			}
		}

		.screen {
			margin-top: 23px;
			margin-bottom: 24px;
			border-radius: 8px;
			height: 64px;
			line-height: 64px;
			background: #fff;

			::v-deep .el-form-item--small.el-form-item {
				margin-bottom: 0;
			}

			::v-deep .el-form-item--small .el-form-item__content {
				line-height: 64px;
			}
		}

		.mod-service {
			min-height: 150px;

			.service-list {
				overflow: auto;

				li {
    				display: inline-block;
					width: 20%;
					overflow: hidden;
					margin-bottom: 2%;
					padding: 0 5px;
					background: #f4f4f4;
					height: 377px;

					dl {
						background: #fff;
						border-radius: 8px;
						height: 100%;
						dt {
							.el-image,&>img{
								width: 100%;
								height: 168px;
								border-radius: 8px 8px 0 0;
							}
							.image-slot{
								height: 100%;
							}
						}

						dd {
							padding: 16px;
							position: relative;

							h3 {
								font-size: 18px;
								max-height: 44px;
    							line-height: 23px;
								-webkit-line-clamp: 2;
							}

							p.desc {
								color: #333;
								opacity: .6;
								font-size: 14px;
								line-height: 20px;
								height: 38px;
								overflow: hidden;
								margin: 15px 0;
								margin-top: 6px;
							}
							p.price{
								font-size: 20px;
								font-weight: bold;
								color: #FF4713;
								margin: 15px 0;
								height: 23px;
								span{
									padding-left: 12px;
									font-size: 14px;
									font-weight: 400;
									text-decoration: line-through;
									color: #B3B3B3;
								}
							}
							.btn_group {
								.normal_button {
									margin-right: 8px;
									img{
										margin-right: 5px;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	::v-deep .topTab .el-tabs__content::-webkit-scrollbar {
		/*滚动条整体样式*/
		width: 10px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}

	::v-deep .topTab .el-tabs__content::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgb(167 151 151 / 62%);
		background: #d3d1d1;
	}

	::v-deep .topTab .el-tabs__content::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ededed;
	}

	.pagination-container {
		background: unset;
	}

	::v-deep ul.el-carousel__indicators--horizontal {
		width: 1200px;
	}
	.banner{
		position: relative;
	}
	.addr{
		background: linear-gradient(180deg, rgba(45,45,45,0) 0%, #888f96 100%);
		height: 46px;
		line-height: 46px;
		color: #fff;
		font-size: 24px;
		position: absolute;
		bottom: 0;
		font-weight: bold;
		width: 100%;
		z-index: 2;
		p{
			width: 1200px;
			margin: 0 auto;
		}
	}
</style>
